export type ImageHistoryItem = {
  id: string;
  isPrimary: boolean;
};

export function applySceneImageMutation<T extends ImageHistoryItem>(input: {
  assets: T[];
  mutation: { type: 'delete'; deletedId: string; nextPrimaryId: string | null };
}): { assets: T[] } {
  const deleted = input.assets.find((item) => item.id === input.mutation.deletedId);
  const currentPrimaryId = input.assets.find((item) => item.isPrimary)?.id ?? null;
  const primaryId = input.mutation.nextPrimaryId ?? (deleted?.isPrimary ? null : currentPrimaryId);
  const assets = input.assets
    .filter((item) => item.id !== input.mutation.deletedId)
    .map((item) => ({
      ...item,
      isPrimary: item.id === primaryId,
    }));
  return { assets };
}
